import { render, staticRenderFns } from "./GeneralError.vue?vue&type=template&id=f6b9b436&scoped=true&"
import script from "./GeneralError.vue?vue&type=script&lang=js&"
export * from "./GeneralError.vue?vue&type=script&lang=js&"
import style0 from "./GeneralError.vue?vue&type=style&index=0&id=f6b9b436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b9b436",
  null
  
)

export default component.exports